import { useMemo } from 'react';
import { VisionCanvas } from '@/components/common/vision-canvas.tsx';
import { CollaborationInitializer } from '@/initializers/collaboration-initializer';
import type { BaseAsset } from '@akavirtual/deai-web-core';

// The JSON you provided, now used as the default scene template.
export const DEFAULT_SCENE_TEMPLATE_FOR_VRM: BaseAsset = {
    "uuid": "1f2a3b4c-5d6e-4f7a-8b9c-0d1e2f3a4b5c",
    "name": "Model Preview Scene",
    "type": "application/scene+json",
    "status": "active",
    "latestVersionId": 52,
    "createdAt": "2025-10-07T07:57:43.000Z",
    "updatedAt": null,
    "version": 1,
    "data": {
        "environment": {
            "uuid": "7e8a36c1-2a6c-4b6a-9383-3e0e71f76827",
            "name": "mainSceneEnv",
            "type": "model/gltf+json",
            "status": "active",
            "latestVersionId": 1,
            "createdAt": "2025-10-07T07:57:43.000Z",
            "updatedAt": null,
            "versions": [
                {
                    "id": 1,
                    "assetUuid": "7e8a36c1-2a6c-4b6a-9383-3e0e71f76827",
                    "version": 1,
                    "data": {},
                    "status": "active",
                    "createdAt": "2025-10-07T07:57:43.000Z",
                    "updatedAt": null
                }
            ],
            "version": 1,
            "data": {}
        },
        "entities": [
            {
                "name": "MainCamera",
                "transform": {
                    "position": [
                        0,
                        1.3,
                        -1.5
                    ],
                    "rotation": [
                        0,
                        180,
                        0
                    ],
                    "scale": [
                        1,
                        1,
                        1
                    ]
                },
                "components": [
                    {
                        "type": "Camera",
                        "properties": {
                            "fieldOfView": 60,
                            "nearClip": 0.1,
                            "farClip": 1000
                        }
                    }
                ]
            },
            {
                "name": "TestAvatar1",
                "transform": {
                    "position": [
                        0,
                        0,
                        0
                    ],
                    "rotation": [
                        0,
                        0,
                        0
                    ],
                    "scale": [
                        1,
                        1,
                        1
                    ]
                },
                "components": [
                    {
                        "type": "Model",
                        "properties": {
                            "asset": {
                                "uuid": "067c7bc2-7703-4f10-a7b8-fa7b3d2cdba6",
                            }
                        }
                    },
                    {
                        "type": "Animator",
                        "properties": {
                            "controller": {
                                "uuid": "9b0c1d2e-3f4a-4c9d-a4e3-f2a1b0c9d8e7",
                                "name": "qatarAvatarAnimator",
                                "type": "application/animator-controller+json",
                                "status": "active",
                                "latestVersionId": 50,
                                "createdAt": "2025-10-07T07:57:43.000Z",
                                "updatedAt": null,
                                "versions": [
                                    {
                                        "id": 50,
                                        "assetUuid": "9b0c1d2e-3f4a-4c9d-a4e3-f2a1b0c9d8e7",
                                        "version": 1,
                                        "data": {
                                            "initialState": "Idle",
                                            "animations": {
                                                "Apology": [
                                                    {
                                                        "uuid": "d3f8a1b2-1b1a-4c8e-8e1b-2a1b8e1b2a1b"
                                                    },
                                                    {
                                                        "uuid": "a1b2c3d4-e5f6-4a9b-8c7d-6e5f4a3b2c1d"
                                                    },
                                                    {
                                                        "uuid": "b2c3d4e5-f6a7-4b8c-9d6e-5f4a3b2c1d0e"
                                                    },
                                                    {
                                                        "uuid": "c3d4e5f6-a7b8-4c9d-a6e5-f4a3b2c1d0e9"
                                                    },
                                                    {
                                                        "uuid": "d4e5f6a7-b8c9-4d8e-b5f4-a3b2c1d0e9f8"
                                                    }
                                                ],
                                                "Greeting": [
                                                    {
                                                        "uuid": "e5f6a7b8-c9d0-4e9f-c4a3-b2c1d0e9f8a7"
                                                    },
                                                    {
                                                        "uuid": "f6a7b8c9-d0e1-4f8a-d3b2-c1d0e9f8a7b6"
                                                    },
                                                    {
                                                        "uuid": "a7b8c9d0-e1f2-4a9b-e2c1-d0e9f8a7b6c5"
                                                    },
                                                    {
                                                        "uuid": "b8c9d0e1-f2a3-4b8c-f1d0-e9f8a7b6c5d4"
                                                    },
                                                    {
                                                        "uuid": "c9d0e1f2-a3b4-4c9d-a0e9-f8a7b6c5d4e3"
                                                    }
                                                ],
                                                "Idle": [
                                                    {
                                                        "uuid": "d0e1f2a3-b4c5-4d8e-b9f8-a7b6c5d4e3f2"
                                                    }
                                                ],
                                                "Listening": [
                                                    {
                                                        "uuid": "e1f2a3b4-c5d6-4e9f-c8a7-b6c5d4e3f2a1"
                                                    },
                                                    {
                                                        "uuid": "f2a3b4c5-d6e7-4f8a-d7b6-c5d4e3f2a1b0"
                                                    },
                                                    {
                                                        "uuid": "a3b4c5d6-e7f8-4a9b-e6c5-d4e3f2a1b0c9"
                                                    },
                                                    {
                                                        "uuid": "b4c5d6e7-f8a9-4b8c-f5d4-e3f2a1b0c9d8"
                                                    },
                                                    {
                                                        "uuid": "c5d6e7f8-a9ba-4c9d-a4e3-f2a1b0c9d8e7"
                                                    }
                                                ],
                                                "PleaseWait": [
                                                    {
                                                        "uuid": "d6e7f8a9-bacb-4d8e-b3f2-a1b0c9d8e7f6"
                                                    },
                                                    {
                                                        "uuid": "e7f8a9ba-cbcd-4e9f-c2a1-b0c9d8e7f6a5"
                                                    },
                                                    {
                                                        "uuid": "f8a9bacb-cdde-4f8a-d1b0-c9d8e7f6a5b4"
                                                    },
                                                    {
                                                        "uuid": "a9bacbcd-deef-4a9b-e0c9-d8e7f6a5b4c3"
                                                    },
                                                    {
                                                        "uuid": "bacbcdde-eff0-4b8c-f9d8-e7f6a5b4c3d2"
                                                    }
                                                ],
                                                "Presenting": [
                                                    {
                                                        "uuid": "cbcddeef-f0a1-4c9d-a8e7-f6a5b4c3d2e1"
                                                    },
                                                    {
                                                        "uuid": "cddeeff0-a1b2-4d8e-b7f6-a5b4c3d2e1f0"
                                                    },
                                                    {
                                                        "uuid": "deeff0a1-b2c3-4e9f-c6a5-b4c3d2e1f0a9"
                                                    },
                                                    {
                                                        "uuid": "eeff0a1b-2c3d-4f8a-d5b4-c3d2e1f0a9b8"
                                                    },
                                                    {
                                                        "uuid": "ff0a1b2c-3d4e-4a9b-e4c3-d2e1f0a9b8c7"
                                                    }
                                                ],
                                                "Talking": [
                                                    {
                                                        "uuid": "0a1b2c3d-4e5f-4b8c-f3d2-e1f0a9b8c7d6"
                                                    },
                                                    {
                                                        "uuid": "1b2c3d4e-5f6a-4c9d-a2e1-f0a9b8c7d6e5"
                                                    },
                                                    {
                                                        "uuid": "2c3d4e5f-6a7b-4d8e-b1f0-a9b8c7d6e5f4"
                                                    },
                                                    {
                                                        "uuid": "3d4e5f6a-7b8c-4e9f-c0a9-b8c7d6e5f4a3"
                                                    }
                                                ],
                                                "Thankyou": [
                                                    {
                                                        "uuid": "4e5f6a7b-8c9d-4f8a-d9b8-c7d6e5f4a3b2"
                                                    },
                                                    {
                                                        "uuid": "5f6a7b8c-9d0e-4a9b-e8c7-d6e5f4a3b2c1"
                                                    },
                                                    {
                                                        "uuid": "6a7b8c9d-0e1f-4b8c-f7d6-e5f4a3b2c1d0"
                                                    },
                                                    {
                                                        "uuid": "7b8c9d0e-1f2a-4c9d-a6e5-f4a3b2c1d0e9"
                                                    },
                                                    {
                                                        "uuid": "8c9d0e1f-2a3b-4d8e-b5f4-a3b2c1d0e9f8"
                                                    }
                                                ],
                                                "Thinking": [
                                                    {
                                                        "uuid": "9d0e1f2a-3b4c-4e9f-c4a3-b2c1d0e9f8a7"
                                                    },
                                                    {
                                                        "uuid": "0e1f2a3b-4c5d-4f8a-d3b2-c1d0e9f8a7b6"
                                                    },
                                                    {
                                                        "uuid": "1f2a3b4c-5d6e-4a9b-e2c1-d0e9f8a7b6c5"
                                                    },
                                                    {
                                                        "uuid": "2a3b4c5d-6e7f-4b8c-f1d0-e9f8a7b6c5d4"
                                                    },
                                                    {
                                                        "uuid": "3b4c5d6e-7f8a-4c9d-a0e9-f8a7b6c5d4e3"
                                                    }
                                                ]
                                            },
                                            "globalTransitions": [
                                                {
                                                    "trigger": "StartIdle",
                                                    "toState": "Idle"
                                                },
                                                {
                                                    "trigger": "StartListening",
                                                    "toState": "Listening"
                                                },
                                                {
                                                    "trigger": "StartTalking",
                                                    "toState": "Talking"
                                                },
                                                {
                                                    "trigger": "StartApology",
                                                    "toState": "Apology"
                                                },
                                                {
                                                    "trigger": "StartGreeting",
                                                    "toState": "Greeting"
                                                },
                                                {
                                                    "trigger": "StartThankyou",
                                                    "toState": "Thankyou"
                                                },
                                                {
                                                    "trigger": "StartPresenting",
                                                    "toState": "Presenting"
                                                },
                                                {
                                                    "trigger": "StartPleaseWait",
                                                    "toState": "PleaseWait"
                                                },
                                                {
                                                    "trigger": "StartThinking",
                                                    "toState": "Thinking"
                                                }
                                            ],
                                            "states": {
                                                "Idle": {
                                                    "animation": "Idle",
                                                    "loop": true,
                                                    "loopMode": "PingPong",
                                                    "fade": 0.6
                                                },
                                                "Listening": {
                                                    "animation": "Listening",
                                                    "loop": true,
                                                    "loopMode": "PingPong",
                                                    "fade": 0.6
                                                },
                                                "Talking": {
                                                    "animation": "Talking",
                                                    "loop": true,
                                                    "loopMode": "PingPong",
                                                    "fade": 0.6
                                                },
                                                "Apology": {
                                                    "animation": "Apology",
                                                    "loop": false,
                                                    "fade": 0.6,
                                                    "onComplete": "Idle"
                                                },
                                                "Greeting": {
                                                    "animation": "Greeting",
                                                    "loop": false,
                                                    "fade": 0.6,
                                                    "onComplete": "Idle"
                                                },
                                                "Thankyou": {
                                                    "animation": "Thankyou",
                                                    "loop": false,
                                                    "fade": 0.6,
                                                    "onComplete": "Idle"
                                                },
                                                "Presenting": {
                                                    "animation": "Presenting",
                                                    "loop": false,
                                                    "fade": 0.6,
                                                    "onComplete": "Idle"
                                                },
                                                "PleaseWait": {
                                                    "animation": "PleaseWait",
                                                    "loop": true,
                                                    "loopMode": "PingPong",
                                                    "fade": 0.6
                                                },
                                                "Thinking": {
                                                    "animation": "Thinking",
                                                    "loop": true,
                                                    "loopMode": "PingPong",
                                                    "fade": 2
                                                }
                                            }
                                        },
                                        "status": "active",
                                        "createdAt": "2025-10-07T07:57:43.000Z",
                                        "updatedAt": null
                                    }
                                ],
                                "version": 1,
                                "data": {
                                    "initialState": "Idle",
                                    "animations": {
                                        "Apology": [
                                            {
                                                "uuid": "d3f8a1b2-1b1a-4c8e-8e1b-2a1b8e1b2a1b"
                                            },
                                            {
                                                "uuid": "a1b2c3d4-e5f6-4a9b-8c7d-6e5f4a3b2c1d"
                                            },
                                            {
                                                "uuid": "b2c3d4e5-f6a7-4b8c-9d6e-5f4a3b2c1d0e"
                                            },
                                            {
                                                "uuid": "c3d4e5f6-a7b8-4c9d-a6e5-f4a3b2c1d0e9"
                                            },
                                            {
                                                "uuid": "d4e5f6a7-b8c9-4d8e-b5f4-a3b2c1d0e9f8"
                                            }
                                        ],
                                        "Greeting": [
                                            {
                                                "uuid": "e5f6a7b8-c9d0-4e9f-c4a3-b2c1d0e9f8a7"
                                            },
                                            {
                                                "uuid": "f6a7b8c9-d0e1-4f8a-d3b2-c1d0e9f8a7b6"
                                            },
                                            {
                                                "uuid": "a7b8c9d0-e1f2-4a9b-e2c1-d0e9f8a7b6c5"
                                            },
                                            {
                                                "uuid": "b8c9d0e1-f2a3-4b8c-f1d0-e9f8a7b6c5d4"
                                            },
                                            {
                                                "uuid": "c9d0e1f2-a3b4-4c9d-a0e9-f8a7b6c5d4e3"
                                            }
                                        ],
                                        "Idle": [
                                            {
                                                "uuid": "d0e1f2a3-b4c5-4d8e-b9f8-a7b6c5d4e3f2"
                                            }
                                        ],
                                        "Listening": [
                                            {
                                                "uuid": "e1f2a3b4-c5d6-4e9f-c8a7-b6c5d4e3f2a1"
                                            },
                                            {
                                                "uuid": "f2a3b4c5-d6e7-4f8a-d7b6-c5d4e3f2a1b0"
                                            },
                                            {
                                                "uuid": "a3b4c5d6-e7f8-4a9b-e6c5-d4e3f2a1b0c9"
                                            },
                                            {
                                                "uuid": "b4c5d6e7-f8a9-4b8c-f5d4-e3f2a1b0c9d8"
                                            },
                                            {
                                                "uuid": "c5d6e7f8-a9ba-4c9d-a4e3-f2a1b0c9d8e7"
                                            }
                                        ],
                                        "PleaseWait": [
                                            {
                                                "uuid": "d6e7f8a9-bacb-4d8e-b3f2-a1b0c9d8e7f6"
                                            },
                                            {
                                                "uuid": "e7f8a9ba-cbcd-4e9f-c2a1-b0c9d8e7f6a5"
                                            },
                                            {
                                                "uuid": "f8a9bacb-cdde-4f8a-d1b0-c9d8e7f6a5b4"
                                            },
                                            {
                                                "uuid": "a9bacbcd-deef-4a9b-e0c9-d8e7f6a5b4c3"
                                            },
                                            {
                                                "uuid": "bacbcdde-eff0-4b8c-f9d8-e7f6a5b4c3d2"
                                            }
                                        ],
                                        "Presenting": [
                                            {
                                                "uuid": "cbcddeef-f0a1-4c9d-a8e7-f6a5b4c3d2e1"
                                            },
                                            {
                                                "uuid": "cddeeff0-a1b2-4d8e-b7f6-a5b4c3d2e1f0"
                                            },
                                            {
                                                "uuid": "deeff0a1-b2c3-4e9f-c6a5-b4c3d2e1f0a9"
                                            },
                                            {
                                                "uuid": "eeff0a1b-2c3d-4f8a-d5b4-c3d2e1f0a9b8"
                                            },
                                            {
                                                "uuid": "ff0a1b2c-3d4e-4a9b-e4c3-d2e1f0a9b8c7"
                                            }
                                        ],
                                        "Talking": [
                                            {
                                                "uuid": "0a1b2c3d-4e5f-4b8c-f3d2-e1f0a9b8c7d6"
                                            },
                                            {
                                                "uuid": "1b2c3d4e-5f6a-4c9d-a2e1-f0a9b8c7d6e5"
                                            },
                                            {
                                                "uuid": "2c3d4e5f-6a7b-4d8e-b1f0-a9b8c7d6e5f4"
                                            },
                                            {
                                                "uuid": "3d4e5f6a-7b8c-4e9f-c0a9-b8c7d6e5f4a3"
                                            }
                                        ],
                                        "Thankyou": [
                                            {
                                                "uuid": "4e5f6a7b-8c9d-4f8a-d9b8-c7d6e5f4a3b2"
                                            },
                                            {
                                                "uuid": "5f6a7b8c-9d0e-4a9b-e8c7-d6e5f4a3b2c1"
                                            },
                                            {
                                                "uuid": "6a7b8c9d-0e1f-4b8c-f7d6-e5f4a3b2c1d0"
                                            },
                                            {
                                                "uuid": "7b8c9d0e-1f2a-4c9d-a6e5-f4a3b2c1d0e9"
                                            },
                                            {
                                                "uuid": "8c9d0e1f-2a3b-4d8e-b5f4-a3b2c1d0e9f8"
                                            }
                                        ],
                                        "Thinking": [
                                            {
                                                "uuid": "9d0e1f2a-3b4c-4e9f-c4a3-b2c1d0e9f8a7"
                                            },
                                            {
                                                "uuid": "0e1f2a3b-4c5d-4f8a-d3b2-c1d0e9f8a7b6"
                                            },
                                            {
                                                "uuid": "1f2a3b4c-5d6e-4a9b-e2c1-d0e9f8a7b6c5"
                                            },
                                            {
                                                "uuid": "2a3b4c5d-6e7f-4b8c-f1d0-e9f8a7b6c5d4"
                                            },
                                            {
                                                "uuid": "3b4c5d6e-7f8a-4c9d-a0e9-f8a7b6c5d4e3"
                                            }
                                        ]
                                    },
                                    "globalTransitions": [
                                        {
                                            "trigger": "StartIdle",
                                            "toState": "Idle"
                                        },
                                        {
                                            "trigger": "StartListening",
                                            "toState": "Listening"
                                        },
                                        {
                                            "trigger": "StartTalking",
                                            "toState": "Talking"
                                        },
                                        {
                                            "trigger": "StartApology",
                                            "toState": "Apology"
                                        },
                                        {
                                            "trigger": "StartGreeting",
                                            "toState": "Greeting"
                                        },
                                        {
                                            "trigger": "StartThankyou",
                                            "toState": "Thankyou"
                                        },
                                        {
                                            "trigger": "StartPresenting",
                                            "toState": "Presenting"
                                        },
                                        {
                                            "trigger": "StartPleaseWait",
                                            "toState": "PleaseWait"
                                        },
                                        {
                                            "trigger": "StartThinking",
                                            "toState": "Thinking"
                                        }
                                    ],
                                    "states": {
                                        "Idle": {
                                            "animation": "Idle",
                                            "loop": true,
                                            "loopMode": "PingPong",
                                            "fade": 0.6
                                        },
                                        "Listening": {
                                            "animation": "Listening",
                                            "loop": true,
                                            "loopMode": "PingPong",
                                            "fade": 0.6
                                        },
                                        "Talking": {
                                            "animation": "Talking",
                                            "loop": true,
                                            "loopMode": "PingPong",
                                            "fade": 0.6
                                        },
                                        "Apology": {
                                            "animation": "Apology",
                                            "loop": false,
                                            "fade": 0.6,
                                            "onComplete": "Idle"
                                        },
                                        "Greeting": {
                                            "animation": "Greeting",
                                            "loop": false,
                                            "fade": 0.6,
                                            "onComplete": "Idle"
                                        },
                                        "Thankyou": {
                                            "animation": "Thankyou",
                                            "loop": false,
                                            "fade": 0.6,
                                            "onComplete": "Idle"
                                        },
                                        "Presenting": {
                                            "animation": "Presenting",
                                            "loop": false,
                                            "fade": 0.6,
                                            "onComplete": "Idle"
                                        },
                                        "PleaseWait": {
                                            "animation": "PleaseWait",
                                            "loop": true,
                                            "loopMode": "PingPong",
                                            "fade": 0.6
                                        },
                                        "Thinking": {
                                            "animation": "Thinking",
                                            "loop": true,
                                            "loopMode": "PingPong",
                                            "fade": 2
                                        }
                                    }
                                }
                            }
                        }
                    },
                    {
                        "type": "Avatar",
                        "properties": {
                            "abilitiesConfig": [
                                {
                                    "type": "speak",
                                    "properties": {
                                        "phonemeMultipliers": {
                                            "aa": 1.2,
                                            "ou": 0.8
                                        }
                                    }
                                }
                            ]
                        }
                    }
                ]
            },
            {
                "name": "GameManager",
                "transform": {
                    "position": [
                        0,
                        0,
                        0
                    ],
                    "rotation": [
                        0,
                        0,
                        0
                    ],
                    "scale": [
                        1,
                        1,
                        1
                    ]
                },
                "components": [
                    {
                        "type": "GameRules",
                        "properties": {
                            "settings": {
                                "uuid": "7f8a9b0c-1d2e-4a9b-e6c5-d4e3f2a1b0c9",
                                "name": "gameSettings",
                                "type": "application/game-settings+json",
                                "status": "active",
                                "latestVersionId": 48,
                                "createdAt": "2025-10-07T07:57:43.000Z",
                                "updatedAt": null,
                                "versions": [
                                    {
                                        "id": 48,
                                        "assetUuid": "7f8a9b0c-1d2e-4a9b-e6c5-d4e3f2a1b0c9",
                                        "version": 1,
                                        "data": {
                                            "difficulty": "normal",
                                            "scoreMultiplier": 1.5,
                                            "enableHints": true
                                        },
                                        "status": "active",
                                        "createdAt": "2025-10-07T07:57:43.000Z",
                                        "updatedAt": null
                                    }
                                ],
                                "version": 1,
                                "data": {
                                    "difficulty": "normal",
                                    "scoreMultiplier": 1.5,
                                    "enableHints": true
                                }
                            }
                        }
                    }
                ]
            }
        ]
    }
} as BaseAsset;


type VrmPreviewProps = {
  /** The UUID of the model asset to be injected into the scene. */
  assetId: string;
  /** An optional, custom scene definition. If not provided, a default template is used. */
  sceneTemplate?: BaseAsset;
};

export const VrmPreview = ({
  assetId,
  sceneTemplate = DEFAULT_SCENE_TEMPLATE_FOR_VRM,
}: VrmPreviewProps) => {
  const definition = useMemo(() => {
    if (!sceneTemplate || !assetId) return null;

    const newDefinition = JSON.parse(JSON.stringify(sceneTemplate));

    const modelEntity = newDefinition.data?.entities?.find((entity: any) =>
      entity.components.some((component: any) => component.type === 'Model')
    );

    if (modelEntity) {
      const modelComponent = modelEntity.components.find(
        (component: any) => component.type === 'Model'
      );
      if (modelComponent) {
        modelComponent.properties.asset.uuid = assetId;
      }
    }

    return newDefinition as BaseAsset;
  }, [sceneTemplate, assetId]); 

  if (!definition) {
    return (
      <div className="flex h-full w-full items-center justify-center text-destructive">
        Invalid Scene Template or Asset ID provided.
      </div>
    );
  }

  return (
    <VisionCanvas
      key={definition.uuid}
      instanceId={`agent-scene-${definition.uuid}`}
      className='h-full w-full'
      definition={definition}
      initializer={CollaborationInitializer}
      assetBaseUrl={window.location.origin}
    />
  );
};